<template>
  <div class="client-card">
    <!-- Информация о клиенте -->
    <clientitem
      class="client-header"
      :firstname="client.firstname || 'нет'"
      :lastname="client.lastname || 'нет'"
      :photo="client.avatar"
      :phone="client.phone !== null ? client.phone : 'нет номера'"
    />

    <!-- Блок с балансами -->
    <div class="balances-block"  v-if="client._id !== '62fd6ad64886f195911e7395'">
      <div class="balance-row" v-if="false">
        <span class="balance-label">Покупок:</span>
        <span class="balance-value">{{ client.total }}</span>
      </div>
      
      <div class="balance-row">
        <span class="balance-label">Бонусы</span>
        <span class="balance-value bonus">{{ client.bonus }}</span>
      </div>

      <div class="balance-row">
        <span class="balance-label">Аванс</span>
        <span class="balance-value deposit">{{ client.avans }}</span>
      </div>
      
      <div class="balance-row">
        <span class="balance-label">Ultimatum Select</span>
        <span class="balance-value select">{{ client.ad_deposit }}</span>
      </div>
    </div>

    <!-- Навигационное меню -->
    <div class="nav-menu" v-if="!['club-owner','club-manager'].includes(channelRole)">
        <div 
            class="nav-item" 
            v-for="(item, index) of menu" 
            :key="'menu' + index" 
            @click="viewUser.module = item.path"
            v-if="client._id !== '62fd6ad64886f195911e7395'"
            
        >
            <span class="nav-label">{{ item.name }}</span>
            <span class="nav-badge" v-if="item.data">{{ item.data }}</span>
        </div>
        
        <div class="nav-item close-btn" @click="closeMyclient()">
            <span class="nav-label">Закрыть</span>
        </div>
    </div>

    <!-- Модальные окна -->
    <transition name="slimeright">
      <slotokno 
        :close="() => viewUser.module = 'dashbord'" 
        :text="'Закрыть профиль'" 
        v-if="viewUser.module == 'clientProfile'"
      >
        <profile />
      </slotokno>
    </transition>
    
    <transition name="slimeright">
      <slotokno 
        :close="() => viewUser = {module:'dashbord',view:true,options:null}" 
        :text="viewUser.options ? 'Закрыть заказы на возврат' : 'Закрыть заказы'" 
        v-if="viewUser.module == 'clientOrders'"
      >
        <Suspense>
          <orders :options="viewUser.options" />
        </Suspense>
      </slotokno>
    </transition>
    
    <transition name="slimeright">
      <slotokno 
        :close="() => viewUser.module = 'dashbord'" 
        :text="'Закрыть заметки'" 
        v-if="viewUser.module == 'clientNotes'"
      >
        <Suspense>
          <notes />
        </Suspense>
      </slotokno>
    </transition>
    
    <transition name="slimeright">
      <slotokno 
        :close="() => viewUser.module = 'dashbord'" 
        :text="'Закрыть возврат'" 
        v-if="viewUser.module == 'clientReturn'"
      >
        <Suspense>
          <returnorder />
        </Suspense>
      </slotokno>
    </transition>
  </div>
</template>

<script setup>
import role from '@/role'
import { useRouter } from 'vue-router'
import { clearUser, client, clientInfo, viewUser, oknoUser } from '@/controlles/client'
import { validPhones } from '@/controlles/general'
import clientitem from '@/components/client/clientitem.vue'
import profile from '@/components/client/profile.vue'
import orders from '@/components/client/orders.vue'
import notes from '@/components/client/notes.vue'
import returnorder from '@/components/client/returnorder.vue'
import { channelRole } from '@/controlles/auth'

const r = useRouter()
const menu = role.headermenu.getMenuClient()

const closeMyclient = () => {
  clearUser()
  oknoUser(false)
}
</script>

<style scoped>
.client-card {
  width: 100%;
  background: var(--bg-primary);
}

/* Хедер клиента */
.client-header {
  border-bottom: 1px solid var(--border-light);
  background: var(--bg-primary);
}

/* Блок с балансами */
.balances-block {
  width: 100%;
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-light);
  padding: 16px 20px;
}

.balance-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid var(--border-light);
}

.balance-row:last-child {
  border-bottom: none;
}

.balance-label {
  font-size: 15px;
  font-weight: 400;
  color: var(--text-secondary);
}

.balance-value {
  font-size: 16px;
  font-weight: 600;
  color: var(--accent-black);
}

.balance-value.bonus {
  color: var(--accent-black);
}

.balance-value.deposit {
  color: var(--accent-black);
}

.balance-value.select {
  color: var(--accent-black);
}

/* Навигационное меню - компактный вариант */
.nav-menu {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  background: var(--bg-primary);
  margin-top: 20px;
}


.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 12px 4px;
  background: var(--tile-bg);
  border: 1px solid var(--tile-border);
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  min-height: 70px;
  position: relative;
  box-shadow: 0 2px 4px var(--shadow-color);
}

.nav-item:hover {
  background: var(--tile-hover-bg);
  border-color: var(--tile-hover-border);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px var(--shadow-color);
}

.nav-item:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px var(--shadow-color);
}

.nav-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--text-primary);
  text-align: center;
  line-height: 1.2;
  padding: 0 2px;
}

.nav-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  background: var(--red);
  color: var(--text-inverse);
  font-size: 10px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid var(--bg-primary);
}

.close-btn {
  background: var(--red);
  border-color: var(--red);
}

.close-btn .nav-label {
  color: var(--text-inverse);
  font-weight: 500;
}

.close-btn:hover {
  background: var(--red-dark);
  border-color: var(--red-dark);
}

/* Анимация */
.slimeright-enter-active,
.slimeright-leave-active {
  transition: all var(--transition-normal);
}

.slimeright-enter-from,
.slimeright-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

/* Темная тема */
html.dark .balances-block {
  background: var(--bg-tertiary);
}

html.dark .nav-item {
  background: var(--bg-secondary);
  border-color: var(--border-medium);
}

html.dark .nav-item:hover {
  background: var(--bg-tertiary);
  border-color: var(--border-dark);
}

html.dark .close-btn {
  background: var(--red);
  border-color: var(--red);
}

html.dark .close-btn:hover {
  background: var(--red-dark);
  border-color: var(--red-dark);
}



</style>